/* eslint-disable array-bracket-newline */
/**
 * Entry-point into simple
 */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import Loader from '../../components/common/Loader';
import ChartDisplay from './ChartDisplay';
import { actionSwitchCurrent } from '../../actions/current';
import { actionChangePrimaryTicker } from '../../actions/grid';

import './styles.scss';
import { KattanaAPI } from '../../store/createStore';

interface urlParams {
  chain?: string;
  address?: string;
}

const TVChartPage = () => {
  const { chain, address }: urlParams = useParams();
  const [isError, setError] = useState<boolean>(false);
  const dispatch = useDispatch();

  const fetchTicker = async () => {
    if (chain && address) {
      const [tickerByBase] =
        (await KattanaAPI.tickerByNetworkAndBase(chain, address)) || [];

      if (tickerByBase) {
        const newTicker = {
          base_precision: 2,
          ...tickerByBase,
          base: tickerByBase.name.split('/')[0],
          quote: tickerByBase.name.split('/')[1],
          id: Number(tickerByBase.id),
        };
        dispatch(actionSwitchCurrent(newTicker));
        dispatch(
          actionChangePrimaryTicker({
            ticker: tickerByBase,
            exchange: tickerByBase.exchange,
          })
        );
        return;
      }

      const [tickerByPair] =
        (await KattanaAPI.tickers({ chain, address })) || [];

      if (tickerByPair) {
        const newTicker = {
          base_precision: 2,
          ...tickerByPair,
          base: tickerByPair.name.split('/')[0],
          quote: tickerByPair.name.split('/')[1],
          id: Number(tickerByPair.id),
        };
        dispatch(actionSwitchCurrent(newTicker));
        dispatch(
          actionChangePrimaryTicker({
            ticker: tickerByBase,
            exchange: tickerByPair.exchange,
          })
        );
        return;
      }
      setError(true);
    }
  };

  useEffect(() => {
    fetchTicker();
  }, [chain, address, dispatch]);

  // TODO: add loading
  // if (current.loading) {
  //   return (
  //     <div className='main_page'>
  //       <Loader className='main_page__loader' />
  //     </div>
  //   );
  // }

  return (
    <div className='main_page'>
      <div className='chart'>
        {!isError && <ChartDisplay />}
        {isError && <div className='errorMessage'>Not found</div>}
      </div>
    </div>
  );
};

export default TVChartPage;
